'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.apps.add', [])
  .controller('AppsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/apps/add/index.js